import type { auth as AuthType } from "@/auth/auth";
import { createServerFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

export const auth = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const { auth: betterAuth } = await import("@/auth/auth");
    const session = (await betterAuth.api.getSession({
      headers: getRequestHeaders(),
    })) as typeof AuthType.$Infer.Session | null;

    if (!session) {
      return {
        status: 200,
        body: { authenticated: false as const, properties: null },
      };
    }

    return {
      status: 200,
      body: {
        authenticated: true as const,
        properties: {
          userId: session.user.id,
          userName: session.user.userName as string | undefined,
          role: session.user.role as string | undefined,
          image: session.user.image || null,
        },
      },
    };
  } catch (e) {
    console.error("[auth] CAUGHT ERROR:", e);
    return {
      status: 200,
      body: { authenticated: false as const, properties: null },
    };
  }
});
